var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "conversations" }, [
    _c(
      "div",
      {
        staticClass:
          "conversations-header d-flex align-center justify-space-between pt-3 px-3 pb-2"
      },
      [
        _c("span", { staticClass: "conversations-title az-ds-card-title" }, [
          _vm._v("Conversas")
        ]),
        _c(
          "div",
          { staticClass: "d-flex align-center" },
          [
            _c(
              "v-btn",
              {
                attrs: {
                  icon: "",
                  small: "",
                  "aria-label": "Nova pasta",
                  title: "Nova pasta"
                },
                on: { click: _vm.openCreateFolder }
              },
              [
                _c("icon-svg", {
                  attrs: {
                    name: "folder-add-outline",
                    size: 18,
                    color: "#8E8E8E"
                  }
                })
              ],
              1
            ),
            _c(
              "v-btn",
              {
                attrs: {
                  icon: "",
                  small: "",
                  "aria-label": "Nova conversa",
                  title: "Nova conversa"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("new-conversation")
                  }
                }
              },
              [
                _c("icon-svg", {
                  attrs: {
                    name: "mdi-message-plus-outline",
                    size: 18,
                    color: "#8E8E8E"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]
    ),
    _c(
      "div",
      { staticClass: "conversations-busca px-3 pt-2 pb-1" },
      [
        _c("input-by-type", {
          staticClass: "ia-sidebar-busca conversations-busca-campo",
          attrs: {
            type: "search",
            value: _vm.buscaDigitada,
            placeholder: "Buscar conversas",
            "max-width": "100%"
          },
          on: { input: _vm.onBuscaInput }
        })
      ],
      1
    ),
    _vm.initialLoading
      ? _c(
          "div",
          { staticClass: "conversations-skeleton pa-2" },
          _vm._l(3, function(i) {
            return _c("BaseLoadingSkeleton", {
              key: i,
              staticClass: "mb-1",
              attrs: { height: "40px" }
            })
          }),
          1
        )
      : _vm.mostraErro
      ? _c(
          "div",
          { staticClass: "conversations-erro text-center px-3 py-6" },
          [
            _c("icon-svg", {
              staticClass: "mb-2",
              attrs: { name: "info-circle", size: 18, color: "secondary" }
            }),
            _c(
              "div",
              { staticClass: "az-text-secondary az-size-12 az-muted mb-3" },
              [
                _vm._v(
                  " Não foi possível carregar suas conversas. Verifique sua conexão e tente novamente. "
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "d-flex justify-center" },
              [
                _c(
                  "BaseButton",
                  {
                    attrs: { underlined: "", "min-width": "80px" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("retry")
                      }
                    }
                  },
                  [_vm._v(" Tentar de novo ")]
                )
              ],
              1
            )
          ],
          1
        )
      : _vm.mostraVazio
      ? _c(
          "div",
          {
            staticClass:
              "conversations-empty conversations-vazio text-caption text-center py-6"
          },
          [_vm._v(" Nenhuma conversa ainda ")]
        )
      : _c(
          "div",
          { staticClass: "conversations-list py-2 px-2" },
          [
            _vm.emBusca
              ? [
                  !_vm.resultadosDaBusca.length
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "conversations-empty text-caption text-center py-4"
                        },
                        [_vm._v(" Nenhuma conversa encontrada ")]
                      )
                    : _vm._e(),
                  _vm._l(_vm.resultadosDaBusca, function(conv) {
                    return _c("ConversationRow", {
                      key: "busca-" + conv.id,
                      attrs: {
                        "mostrar-agente": "",
                        conversation: conv,
                        selected: conv.id === _vm.selectedId,
                        folders: _vm.folders
                      },
                      on: {
                        select: _vm.onSelect,
                        rename: _vm.onRename,
                        "request-delete": _vm.confirmDelete,
                        move: _vm.moveConversation
                      }
                    })
                  })
                ]
              : _vm._e(),
            !_vm.emBusca
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "conversations-secao-header",
                      attrs: {
                        "aria-expanded": _vm.secoes.recentes ? "true" : "false"
                      },
                      on: {
                        click: function($event) {
                          return _vm.alternarSecao("recentes")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "conversations-secao-titulo az-ds-label"
                        },
                        [_vm._v("Recentes")]
                      ),
                      _c("icon-svg", {
                        staticClass: "conversations-secao-chevron",
                        class: {
                          "conversations-secao-chevron--fechada": !_vm.secoes
                            .recentes
                        },
                        attrs: {
                          name: "arrow-down-light",
                          size: 12,
                          color: "var(--neutral-400)"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.secoes.recentes
                    ? [
                        _vm._l(_vm.recentes.visiveis, function(conv) {
                          return _c("ConversationRow", {
                            key: "recente-" + conv.id,
                            attrs: {
                              "mostrar-agente": "",
                              conversation: conv,
                              selected: conv.id === _vm.selectedId,
                              folders: _vm.folders
                            },
                            on: {
                              select: _vm.onSelect,
                              rename: _vm.onRename,
                              "request-delete": _vm.confirmDelete,
                              move: _vm.moveConversation
                            }
                          })
                        }),
                        _vm.recentes.temMais
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "conversations-ver-todas ia-texto-auxiliar",
                                attrs: {
                                  "aria-expanded": _vm.recentesExpandido
                                    ? "true"
                                    : "false"
                                },
                                on: { click: _vm.alternarRecentes }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.recentesExpandido
                                        ? "Ver menos"
                                        : "Ver todas (" +
                                            _vm.recentes.total +
                                            ")"
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "conversations-secao-header mt-2",
                      attrs: {
                        "aria-expanded": _vm.secoes.pastas ? "true" : "false"
                      },
                      on: {
                        click: function($event) {
                          return _vm.alternarSecao("pastas")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "conversations-secao-titulo az-ds-label"
                        },
                        [_vm._v("Pastas")]
                      ),
                      _c("icon-svg", {
                        staticClass: "conversations-secao-chevron",
                        class: {
                          "conversations-secao-chevron--fechada": !_vm.secoes
                            .pastas
                        },
                        attrs: {
                          name: "arrow-down-light",
                          size: 12,
                          color: "var(--neutral-400)"
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            !_vm.emBusca && _vm.secoes.pastas && _vm.hasFolders
              ? _vm._l(_vm.folders, function(folder) {
                  return _c(
                    "div",
                    { key: folder.id, staticClass: "conversations-folder" },
                    [
                      _c("FolderItem", {
                        attrs: {
                          folder: folder,
                          count: folder.conversation_count || 0,
                          expanded: !!_vm.expandedMap[folder.id]
                        },
                        on: {
                          toggle: _vm.toggleFolder,
                          rename: _vm.openRenameFolder,
                          delete: _vm.confirmDeleteFolder,
                          "drop-conversation": _vm.moveConversation
                        }
                      }),
                      _vm.expandedMap[folder.id]
                        ? _c(
                            "div",
                            {
                              staticClass: "conversations-folder__children pl-4"
                            },
                            [
                              _vm._l(
                                _vm.conversasPorPasta[folder.id] || [],
                                function(conv) {
                                  return _c("ConversationRow", {
                                    key: conv.id,
                                    attrs: {
                                      "mostrar-agente": "",
                                      conversation: conv,
                                      selected: conv.id === _vm.selectedId,
                                      folders: _vm.folders
                                    },
                                    on: {
                                      select: _vm.onSelect,
                                      rename: _vm.onRename,
                                      "request-delete": _vm.confirmDelete,
                                      move: _vm.moveConversation
                                    }
                                  })
                                }
                              ),
                              _vm.pastasCarregando[folder.id]
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "conversations-folder__empty az-text-small text-center py-2 px-3"
                                    },
                                    [_vm._v(" Carregando… ")]
                                  )
                                : !(_vm.conversasPorPasta[folder.id] || [])
                                    .length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "conversations-folder__empty az-text-small text-center py-2 px-3"
                                    },
                                    [_vm._v(" Nenhuma conversa nesta pasta ")]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                })
              : _vm._e(),
            !_vm.emBusca &&
            _vm.secoes.pastas &&
            (_vm.hasFolders || _vm.hasLoose)
              ? _c(
                  "div",
                  {
                    staticClass: "conversations-loose mt-1",
                    class: {
                      "conversations-loose--drag-over": _vm.looseDragOver
                    },
                    on: {
                      dragover: _vm.onLooseDragOver,
                      dragleave: _vm.onLooseDragLeave,
                      drop: _vm.onLooseDrop
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "conversations-loose__header d-flex align-center az-gap-small pt-2 pb-1 px-3"
                      },
                      [
                        _c("span", { staticClass: "az-ds-label" }, [
                          _vm._v("Sem pasta")
                        ]),
                        _c(
                          "span",
                          { staticClass: "az-ds-badge-count az-neutral ml-2" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.looseConversations.length) + " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._l(_vm.looseConversations, function(conv) {
                      return _c("ConversationRow", {
                        key: conv.id,
                        attrs: {
                          "mostrar-agente": "",
                          conversation: conv,
                          selected: conv.id === _vm.selectedId,
                          folders: _vm.folders
                        },
                        on: {
                          select: _vm.onSelect,
                          rename: _vm.onRename,
                          "request-delete": _vm.confirmDelete,
                          move: _vm.moveConversation
                        }
                      })
                    })
                  ],
                  2
                )
              : _vm._e()
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }